import { render, staticRenderFns } from "./Walle-Withdraw.vue?vue&type=template&id=2468781d&"
import script from "./Walle-Withdraw.vue?vue&type=script&lang=js&"
export * from "./Walle-Withdraw.vue?vue&type=script&lang=js&"
import style0 from "./Walle-Withdraw.vue?vue&type=style&index=0&id=2468781d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports